var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.meetingId != '' && _vm.canJoin)?_c('iframe',{attrs:{"src":_vm.FrameUrl,"width":"100%","height":"600px","frameborder":"0"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }